import { render } from "./NotFound.vue?vue&type=template&id=3b529c08"
const script = {}
script.render = render

export default script